import React, { memo, useEffect, useState } from 'react';
import {
  Marker,
  Polygon,
  InfoWindow,
} from '@react-google-maps/api';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import { Map, Visibility } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import { nthIndexOf } from 'hooks/Pipe';
import { Link } from 'react-router-dom';
import { formatDate } from 'hooks/Pipe';
import SplitSheet from './SplitSheet';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';

function OrdersMap(props) {
  const { orders, setOrders, routes, setRoutes, sheetDistribution } = props;
  const { sheets, setSheets } = props;
  const [infoWindowData, setInfoWindowData] = useState();
  const [mapCenter, setMapCenter] = useState({
    lat: -14.07543457346045,
    lng: -75.73423487506565,
  });
  const [mapZoom, setMapZoom] = useState(14);
  const [polygons, setPolygons] = useState([]);

  useEffect(() => {
    if (orders.length > 0) {
      setMapCenter({
        lat: parseFloat(orders[0].lat),
        lng: parseFloat(orders[0].lng),
      });
    }
  }, [orders]);

  return (
    <GridContainer>
      <GridItem xs={12} style={{ position: 'relative' }}>
        <CardContainer title="Mapa" collapse icon={<Map />}>
          <GoogleMapCustom
            mapContainerStyle={{
              width: '100%',
              height: '400px',
            }}
            zoom={mapZoom}
            center={mapCenter}
            options={{
              disableDoubleClickZoom: true,
            }}
          >
            {/* Rutas */}
            {routes.map((route) => {
              return (
                <Polygon
                  key={route.id}
                  path={route.geometry}
                  options={{
                    fillColor: route.layer.color,
                  }}
                />
              );
            })}

            {/* Poligonos para seleccionar pedidos */}
            {polygons.map((polygon, i) => {
              return (
                <Polygon
                  key={i}
                  path={polygon}
                  onDblClick={() => {
                    if (window.confirm('Eliminar el poligono seleccionado ?')) {
                      setPolygons((polygons) => {
                        let newPolygons = [...polygons];
                        newPolygons.splice(i, 1);
                        return newPolygons;
                      });
                    }
                  }}
                />
              );
            })}

            {/* Pedidos */}
            {orders.map((order) => {
              return (
                <Marker
                  key={order.id}
                  position={{
                    lat: parseFloat(order.lat),
                    lng: parseFloat(order.lng),
                  }}
                  onClick={() => setInfoWindowData(order)}
                  icon={
                    order.pinColor !== undefined
                      ? `http://maps.google.com/mapfiles/ms/icons/${order.pinColor}-dot.png`
                      : undefined
                  }
                  options={{
                    label: {
                      color: 'white',
                      className: 'map-label',
                      text:
                        nthIndexOf(order.CardName, ' ', 2) !== -1
                          ? order.CardName.substr(0, nthIndexOf(order.CardName, ' ', 2))
                          : order.CardName,
                    },
                  }}
                />
              );
            })}

            {/* InfoWindow */}
            {infoWindowData !== undefined && (
              <InfoWindow
                position={{
                  lat: parseFloat(infoWindowData.lat),
                  lng: parseFloat(infoWindowData.lng),
                }}
                onCloseClick={() => setInfoWindowData(undefined)}
                options={{
                  pixelOffset: {
                    width: 0,
                    height: -25,
                  },
                }}
              >
                <div style={{ position: 'relative' }}>
                  <Button
                    justIcon
                    round
                    simple
                    color="primary"
                    style={{ position: 'absolute', top: '-20px', right: 0 }}
                  >
                    <Link
                      to={`/admin/ventas/operaciones/pedidos/#${infoWindowData.id}`}
                      target="_blank"
                    >
                      <Visibility />
                    </Link>
                  </Button>
                  <h5>
                    {infoWindowData.CardCode}
                    {infoWindowData.CardName}
                  </h5>
                  <li>
                    <span>Monto: </span>
                    S/ {parseFloat(infoWindowData.total_order).toFixed(2)}
                  </li>
                  <li>
                    <span>Dir: </span>
                    {infoWindowData.Address2}
                  </li>
                  <li>
                    <span>Fecha: </span>
                    {formatDate(infoWindowData.date_order)}
                  </li>
                  <li>
                    <span>Vendedor: </span>
                    {infoWindowData.SlpName}
                  </li>
                </div>
              </InfoWindow>
            )}
          </GoogleMapCustom>
        </CardContainer>
      </GridItem>
      <GridItem xs={12}>
        <SplitSheet
          sheetDistribution={sheetDistribution}
          orders={orders}
          setOrders={setOrders}
          routes={routes}
          setRoutes={setRoutes}
          sheets={sheets}
          setSheets={setSheets}
        />
      </GridItem>
    </GridContainer>
  );
}

export default memo(OrdersMap);
